import axios from 'axios'
import store from '@/vuex/store.js'
import JSONBig from 'json-bigint'
import Cookies from "js-cookie";
import utils from "@/utils/utils";

const JSONbigString = JSONBig({storeAsString: true})

//根据不同的环境更改不同的baseUrl

let baseUrl = window.location.protocol + '//' + window.location.hostname
let token = ''

if (process.env.NODE_ENV === 'development') {
  baseUrl = '/api'
}

axios.defaults.timeout = 60000
axios.defaults.baseURL = baseUrl + '/back'
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
axios.defaults.transformResponse = [
  function (data) {
    try {
      // 如果转换成功，则直接把结果返回
      return JSONbigString.parse(data)
    } catch {
      // 如果转换失败了，我们在这里把数据原封不动的直接返回给请求使用
      return data
    }
  }
]

//http request 拦截器
axios.interceptors.request.use(
    config => {
      config.data = JSON.stringify(config.data)
      config.headers.common['Authorization'] = JSON.parse(Cookies.get(utils.getTokenKey()) || null)?.yzb?.yzbToken
      // config.headers.terminal = 1
      return config
    },
    err => {
      return Promise.reject(err)
    }
)

//响应拦截器及异常处理
axios.interceptors.response.use(response => {
  return response
}, err => {
  return Promise.resolve(err.response)
})


/**
 * 封装get方法
 * @param url
 * @param params
 * @returns {Promise}
 */

export function get(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params
    })
        .then(response => {
          resolve(response.data)
        })
        .catch(err => {
          reject(err)
        })
  })
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @param others
 * @returns {Promise}
 */

export function post(url, data = {}, others = {}) {
  // let Data = qs.stringify(data);
  return new Promise((resolve, reject) => {
    axios.post(url, data, others)
        .then(response => {
          resolve(response.data)
        }, err => {
          reject(err)
        })

  })
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.patch(url, data)
        .then(response => {
          resolve(response.data)
        }, err => {
          reject(err)
        })
  })
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.put(url, data)
        .then(response => {
          resolve(response.data)
        }, err => {
          reject(err)
        })
  })
}

/**
 * 封装delete请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function _delete(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.delete(url, data)
        .then(response => {
          resolve(response.data)
        }, err => {
          reject(err)
        })
  })
}

/**
 * 下面是获取数据的接口
 */
export const request = {
  addBid(paramObj = {}) {//后台-添加标讯
    return post('bid/save', paramObj)
  },
  openMember(paramObj = {}) {//后台-通过手机号开通会员
    return post('members/join', paramObj)
    // return post('http://192.168.1.6:8088/members/join', paramObj);
  },
  queryMemberStatus(paramObj = {}) {//查询会员开通状态
    return post('members/status', paramObj)
  },
  renewMember(paramObj = {}) {//开通/续费会员
    return post('members/opening/vip', paramObj)
  },
  findByTitle(paramObj = {}) {
    return post('es/findByTitle', paramObj)
  },
  sendSmsCode(paramObj = {}) {//发送短信验证码
    return post('user/sendSmsCode', paramObj)
  },
  register(paramObj = {}) {//用户注册
    return post('user/register', paramObj)
  },
  getBackPassword(paramObj = {}) {//用户注册
    return post('user/forgot/password', paramObj)
  },
  login(paramObj = {}) {//用户登录
    return post('auth/login', paramObj)
  },
  currentUser(paramObj = {}) {//获取用户权限
    return post('user/currentUser', paramObj)
  },
  verificationToken(paramObj = {}) {//验证用户token是否有效
    return get('user/verification', paramObj)
  },

  exportTableTenderingMessage(paramObj = {}) {//导出标讯表格
    // return post('export/back/bid', paramObj, {responseType: 'blob', timeout: 60000 * 3})
    return post('export/backBid', paramObj, {responseType: 'blob', timeout: 60000 * 3})

  },
  exportSubscribeMessage(paramObj = {}) {//导出获得订阅筛选表格
    return post('export/front/mySubscribe', paramObj, {responseType: 'blob', timeout: 60000 * 3})
  },
  /**
   * 导出数据统计
   * @param data
   * @param data.announceTypes
   * @param data.purchase
   * @param data.purchaser
   * @param data.province
   * @param data.queryText
   * @param data.searchType
   * @param data.searchMethod
   * @param data.startDt
   * @param data.endDt
   * @param data.startMoney
   * @param data.endMoney
   * @param data.industryType // 行业类型(1电梯;2家具;3汽车;4物业;5照明;6空调;7服务器;8视频会议;9体育;10医疗)
   */
  exportDataStatistics(data) {
    return post('bid/dataStatistics/back/exportData', data, {responseType: 'blob', timeout: 60000 * 3})
  },
  searchCondition(paramObj = {}) {//获取标讯筛选条件列表 name
    return post('dic/condition', paramObj)
  },
  searchConditionWithId(paramObj = {}) {//获取标讯筛选条件列表
    return post('dic/condition/vos', paramObj)
  },
  //获取后台管理标讯列表(旧的)
  tenderingMessageList(paramObj = {}) {
    return post('bid/back/list', paramObj)
  },
  // 获取后台管理标讯列表(新的)
  tenderingMessageListNew(paramObj = {}) {
    return post('/bid/back/query', paramObj)
  },
  deleteTenderingMessage(paramObj = {}) {//删除单条标讯数据
    return post('bid/bidInfo/remove', paramObj)
  },
  batchDeletion(paramObj = {}) {//批量删除标讯管理列表数据
    return post('bid/bidInfo/batch', paramObj)
  },
  tenderingMessageInfo(paramObj = {}) {//获取单条标讯信息
    return get('bid/bidInfo', paramObj)
  },
  updateTenderingMessage(paramObj = {}) {//更新单条标讯信息
    return post('bid/bidInfo/update', paramObj)
  },
  searchAnnouncement(paramObj = {}) {//查询公告类型字典
    return get('dic/announcement', paramObj)
  },
  searchPurchase(paramObj = {}) {//查询采购方式字典
    return get('dic/purchase', paramObj)
  },
  searchPurchaser(paramObj = {}) {//查询采购人字典
    return get('dic/purchaser', paramObj)
  },
  searchRegion(paramObj = {}) {//查询地区
    return get('dic/region', paramObj)
  },
  tagsList(paramObj = {}) {//列表、查询品目接口
    return post('item/listItem', paramObj)
  },
  modifyItemName(paramObj = {}) {//修改品目名称
    return post('item/modifyItemName', paramObj)
  },
  modifyExtendItems(paramObj = {}) {//修改品目近义词
    return post('item/modifyExtendItems', paramObj)
  },
  listItemChildren(paramObj = {}) {//根据品目编码，列表该品目下属所有子品目
    return post('item/listItemChildren', paramObj)
  },
  addItem(paramObj = {}) {//添加品目
    return post('item/addItem', paramObj)
  },
  deleteItems(paramObj = {}) {//批量删除品目
    return post('item/deleteItems', paramObj)
  },

  collectionTaskList(paramObj = {}) {//获取采集器任务列表
    return post('collector/list', paramObj)
  },
  startCollectionTaskList(paramObj = {}) {//批量启动/停止采集器任务列表数据
    return post('collector/artificial/batch', paramObj)
  },
  // 订单列表全部已读
  clearOrderMessage(paramObj = {}) {
    return post('deal/order/read/clear', paramObj)
  },
  // 发票列表全部已读
  clearInvoiceMessage(paramObj = {}) {
    return post('invoice/back/read/clear', paramObj)
  },
  tradePriceList(paramObj = {}) {//请求交易管理价格列表
    return get('deal/price/list', paramObj)
  },
  modifyPrice(paramObj = {}) {//修改交易管理-定价价格
    return post('deal/modify/price', paramObj)
  },
  discountList(paramObj = {}) {//查询折扣管理列表
    return get('deal/discount/list', paramObj)
  },
  addDiscount(paramObj = {}) {//添加折扣
    return post('deal/add/discount', paramObj)
  },
  deleteDiscount(paramObj = {}) {//删除/批量删除折扣
    return post('deal/delete/discount', paramObj)
  },
  editDiscount(paramObj = {}) {//修改折扣状态
    return post('deal/edit/discount', paramObj);
  },

  orderList(paramObj = {}) {//查询订单列表(后台)
    // return post('deal/order/list',paramObj)
    return post('deal/order/info/list', paramObj)
    // return post('http://192.168.1.6:8088/deal/order/info/list', paramObj)
  },
  myOrderList(paramObj = {}) {//查询订单列表(前端)
    return post('deal/order/list/user', paramObj)
  },
  orderDetail(paramObj = {}) {//查询订单详情
    return get('deal/order/query', paramObj)
  },
  orderPayDone(paramObj = {}) {//强制完成订单支付
    return post('deal/corporate/transfer', paramObj)
  },
  deleteOrder(paramObj = {}) {//删除订单
    return post('deal/delete/orders', paramObj)
  },
  payAliPay(paramObj = {}) {//调用支付宝支付
    return post('pay/aliPay', paramObj)
  },
  wxPay(paramObj = {}) {//调用微信支付
    return post('pay/wxPay', paramObj)
  },
  transferPay(paramObj = {}) {
    return post('deal/confirm/transfer', paramObj)
  },
  invoiceList(paramObj = {}) {//查询发票抬头列表
    return post('invoice/back/list', paramObj)
  },
  editInvoice(paramObj = {}) {//查询发票抬头列表
    return post('invoice/edit/invoice', paramObj)
  },
  myInvoiceOrderList(paramObj = {}) {//未开发票列表
    return post('invoice/front/subscribe/orders', paramObj)
  },
  myInvoiceList(paramObj = {}) {//已开发票列表
    return post('invoice/front/list', paramObj)
  },
  myInvoiceDetail(paramObj = {}) {//已开发票详情
    return get('invoice/back/currency', paramObj)
  },
  addInvoice(paramObj = {}) {//添加发票
    return post('invoice/front/add', paramObj)
  },
  returnInvoiceReason(paramObj = {}) {//获取退票原因列表
    return get('dic/invoice/refund', paramObj)
  },
  returnInvoice(paramObj = {}) {//申请退票
    return post('invoice/front/refund', paramObj)
  },
  exportInvoice(paramObj = {}) {//导出发票
    return post('invoice/back/export', paramObj, {responseType: 'blob', timeout: 60000 * 3});
  },
  addBidAttention(paramObj = {}) {//用户收藏某一标讯
    return post('search/addBidAttention', paramObj)
  },
  cancelBidAttention(paramObj = {}) {//用户取消收藏某一标讯
    return post('search/cancelBidAttention', paramObj)
  },
  queryBidTitle(paramObj = {}) {//按照标题搜索标讯信息
    return post('search/queryBidTitle', paramObj)
  },
  queryBidContent(paramObj = {}) {//全文搜索标讯信息
    return post('search/queryBidContent', paramObj)
  },
  queryBidTitleInSubscribe(paramObj = {}) {//我的订阅中标讯标题搜索接口
    return post('search/queryBidTitleInSubscribe', paramObj)
  },
  queryBidContentInSubscribe(paramObj = {}) {//我的订阅中标讯全文搜索接口
    return post('search/queryBidContentInSubscribe', paramObj)
  },
  queryBidTitleInAttention(paramObj = {}) {//我的收藏中标讯标题搜索接口
    return post('search/queryBidTitleInAttention', paramObj)
  },
  queryBidContentInAttention(paramObj = {}) {//我的收藏中标讯全文搜索接口
    return post('search/queryBidContentInAttention', paramObj)
  },
  queryBidDetail(paramObj = {}) {//标讯详情
    return post('search/queryBidDetail', paramObj)
  },
  listTop2LevelItem(paramObj = {}) {//列表top2品目列表
    return post('item/listTop2LevelItem', paramObj)
  },
  computeSubscribePrice(paramObj = {}) {//计算订阅器价格
    return post('subscribe/computePrice', paramObj)
  },
  submitSubscribe(paramObj = {}) {//提交订阅器
    return post('subscribe/submitSubscribe', paramObj)
  },
  renew(paramObj) {//续费订阅器
    return post('renewals/subscribe', paramObj)
  },
  getBindingCode(paramObj = {}) {//获取微信授权二维码
    return get('wx/user/authorize', paramObj)
  },
  getBindingResult(paramObj = {}) {//获取微信授权结果
    return get('wx/user/bundling/info', paramObj)
  },
  unBinging(paramObj = {}) {//获取微信授权结果
    return get('wx/user/unBundling', paramObj)
  },
  editSubscribe(paramObj = {}) {//编辑订阅器
    return post('subscribe/editSubscribe', paramObj)
  },
  cancelSubscriber(paramObj = {}) {//取消订单
    return post('subscribe/cancel/order', paramObj)
  },
  findSubscriberMessageNum(paramObj = {}) {//查询我的订阅未读消息条数
    return get('subscribe/findSubscribeNum', paramObj)
  },
  subscriberInfo(paramObj = {}) {//查询订阅器信息
    return post('subscribe/findSubscribe', paramObj)
  },
  findSubscribeByUserId(userid) {//查询订阅器信息 订单
    return post('deal/findSubscribeByUserId', {userid})
  },
  clearSubscribeNum(paramObj = {}) {//清空未读订阅消息
    return get('subscribe/clearSubscribeNum', paramObj)
  },
  hasNewMessage(paramObj = {}) {// 是否有新消息
    return get('message/front/hasMsg', paramObj)
  },
  notice(paramObj = {}) {// 消息中心列表
    return post('/message/front/notice', paramObj)
  },
  read(paramObj = {}) {// 将消息变为已读
    return post('/message/front/read', paramObj)
  },
  currency(paramObj = {}) {// 获取消息详情
    return get('/message/currency', paramObj)
  },
  helpList(paramObj = {}) {// 获取帮助中心列表信息
    return post('/help/currency/list', paramObj)
  },
  helpData(paramObj = {}) {// 根据id查询帮助消息
    return get('/help/currency', paramObj)
  },
  addHelp(paramObj = {}) {//添加帮助中心消息
    return post('/help/back/add', paramObj)
  },
  editHelp(paramObj = {}) {//添加帮助中心消息
    return post('/help/back/edit', paramObj)
  },
  deleteHelp(paramObj = {}) {
    return _delete(`/help/back/${paramObj.id}`)
  },
  userInfo(paramObj = {}) {// 获取用户信息
    return get('/user/query/userInfo', paramObj)
  },
  changeUserInfo(paramObj = {}) {// 修改用户信息
    return post('/user/edit/userInfo', paramObj)
  },
  /****************************** 管理员管理 ******************************/
  addRole(paramObj = {}) {
    return post('/user/role/backup/add', paramObj)
  },
  roleList(paramObj = {}) {
    return post('/user/role/backup/list', paramObj)
  },
  editRole(paramObj = {}) {
    return post('/user/role/backup/edit', paramObj)
  },
  deleteRole(paramObj = {}) {
    return post('/user/role/backup/delete', paramObj)
  },
  // 权限列表
  privilegeList(paramObj = {}) {
    return post('/role/privilege/backup/list', paramObj)
  },
  // 添加角色
  addPrivilege(paramObj = {}) {
    return post('/role/privilege/backup/add', paramObj)
  },
  // 菜单树
  allPrivilege(paramObj = {}) {
    return post('/role/privilege/backup/allPrivilege', paramObj)
  },
  // 删除角色
  delPrivilege(paramObj = {}) {
    return post('/role/privilege/backup/delete', paramObj)
  },
  // 编辑角色
  editPrivilege(paramObj = {}) {
    return post('/role/privilege/backup/edit', paramObj)
  },
  /****************************** 菜单管理 ******************************/
  // 新增菜单
  addMenuList(paramObj = {}) {
    return post('/role/privilege/backup/addPrivilege', paramObj)
  },
  // 获取一级菜单列表
  firstLevelMenuList(paramObj = {}) {
    return post("/role/privilege/backup/firstLevelMenuList", paramObj)
  },
  //修改菜单权限
  editMenuItem(paramObj = {}) {
    return post('/role/privilege/backup/editPrivilege', paramObj)
  },
  // 删除菜单
  deleteMenuItem(paramObj = {}) {
    return post('/role/privilege/backup/deletePrivilege', paramObj)
  },
  // 根据一级菜单查询二级
  getMenuListByParentId(paramObj = {}) {
    return post('/role/privilege/backup/getMenuListByParentId', paramObj)
  },
  // 订单详情
  getOrderDetail(paramObj = {}) {
    return get('/deal/order/info/detail', paramObj)
  },

  //订单备注
  updateNotes(paramObj = {}) {
    return post('/deal/order/info/updateNotes', paramObj)
  },

  // 订单小红点
  orderChangeNum(paramObj = {}) {
    return get('/deal/order/info/checkExistNotReadOrder', paramObj)
  },
  // 发票详情
  getInvoiceDetail(paramObj = {}) {
    return get('/invoice/back/currency', paramObj)
  },
  // 发票小红点
  invoiceChangeNum(paramObj = {}) {
    return get('/invoice/back/currency/checkExistNotReadInvoice', paramObj)
  },
  // 获取角色列表（管理员设置）
  allRoleList(paramObj = {}) {
    return post('/role/privilege/backup/allRole', paramObj)
  },
  // 获取会员列表
  membersList(paramObj = {}) {
    return post('/members/list', paramObj)
  },
  // 修改会员到期时间接口
  editMembersDueTime(paramObj = {}) {
    return post('/members/editDueTime', paramObj)
  },
  // 查询订阅器
  querySubscribe(paramObj = {}) {
    return post('/members/querySubscribe', paramObj)
  },
  /* *定时任务管理相关******************************/
  // 获取任务列表接口
  loadScheduledList(paramObj = {}) {
    return post('/scheduled/loadScheduledList', paramObj)
  },
  // 保存定时器任务
  saveScheduled(paramObj = {}) {
    return post('/scheduled/saveScheduled', paramObj)
  },
  // 修改定时器任务
  updateScheduled(paramObj = {}) {
    return post('/scheduled/updateScheduled', paramObj)
  },
  // 删除定时任务接口
  deleteScheduled(id) {
    return post('/scheduled/deleteScheduled', {id})
  },
  /* * 标讯管理 获取时间的筛选项 */
  // 获取全部的筛选接口
  findAllTime(data = {}) {
    return post('/dic/findAllTime', data)
  },
  // 获取最近月度
  findMonth(data = {}) {
    return post('/dic/findMonth', data)
  },
  // 获取最近季度
  findQuarter(data = {}) {
    return post('/dic/findQuarter', data)
  },
  // 获取最近年度
  findYear(data = {}) {
    return post('/dic/findYear', data)
  },
  // 批量更新es索引接口
  batchUpdateEs(data = {}) {
    return post('/bid/back/batchUpdateEs', data)
  },
  // 后台首页搜索分类接口
  getQueryBidSearchTypeDictionary(data = {}) {
    return post('/search/getQueryBidSearchTypeDictionary', data)
  },
  /****************       数据统计分析接口      *******************/
  /**
   * 获取同比/环比数据
   */
  getHeaderData() {
    let d = store.state.statisticsParams
    let mustNotIds = sessionStorage.mustNotIds || ''
    if (d.startTime === '' || d.endTime === '') {
      return
    }
    return post('/dataStatistics/getAmountPurchasedStatisticsHeaderData', {...d, mustNotIds})
  },
  /**
   * 获取首页图表数据
   */
  getStatisticsHomeData() {
    let d = store.state.statisticsParams
    if (d.startTime === '' || d.endTime === '') {
      return
    }
    return post('/dataStatistics/getAmountPurchasedStatisticsHomeData', {...d})
  },
  /**
   * 获取自定义的行业||细分市场数据
   * @param {number} type 所属类型(1公共、2个人)
   * @param {number} topType 数据是行业还是细分市场（1行业、2细分市场）
   */
  getCustomTag(type, topType) {
    let user_id = store.state.userid
    if (type === 1) user_id = ''
    return post('/dataStatistics/getName', {type, topType, user_id})
  },

  /**
   * 获取行业的关键词
   * @param {string} name 行业或自定义细分市场名称
   * @param {number} type 所属类型(1公共、2个人)
   * @param {number} topType 数据是行业还是细分市场（1行业、2细分市场）
   */
  getKeyword(name, type = 1, topType = 1) {
    return post('/dataStatistics/getKeyword', {name, type, topType})
  },
  /**
   * 根据字符查询省、市筛选项
   * @param {string} searchTitle 要搜索的字符串
   */
  getCity(searchTitle) {
    return post('/dataStatistics/getCity', {searchTitle})
  },
  /**
   * 新增（创建）标签内容（行业||细分市场）
   * @param {Object} data 修改标签所需要的参数
   * @example
   * data: {
   *   name: "", //行业或自定义细分市场名称
   *   type: 1, // 所属类型(1公共、2个人)
   *   keyword: "", // 关键词
   *   stopword: "", // 不包含的关键词
   *   user_id: "", // 个人行业关键词用户ID(公共类型关键词用户ID未空)
   *   topType: 1, // 数据是行业还是细分市场（1行业、2细分市场）
   * }
   */
  insertKeyWord(data) {
    let user_id = store.state.userid
    return post('/dataStatistics/insertKeyWord', {...data, user_id})
  },
  /**
   * 修改标签内容（行业||细分市场）
   * @param {Object} data 修改标签所需要的参数
   * @example
   * data: {
   *   name: "", //行业或自定义细分市场名称
   *   type: 1, // 所属类型(1公共、2个人)
   *   keyword: "", // 关键词
   *   stopword: "", // 不包含的关键词
   *   user_id: "", // 个人行业关键词用户ID(公共类型关键词用户ID未空)
   *   topType: 1, // 数据是行业还是细分市场（1行业、2细分市场）
   * }
   */
  updateKeyWord(data) {
    let user_id = store.state.userid
    if (data.type === 1) user_id = ''
    return post('/dataStatistics/updateKeyWord', {...data, user_id})
  },
  /**
   * 删除标签
   * @param {string} name 需要删除标签的内容
   * @param {number} topType 数据是行业还是细分市场（1行业、2细分市场）
   */
  deleteKeyWord(name, topType) {
    let user_id = store.state.userid
    return post('/dataStatistics/deleteKeyWord', {name, topType, user_id})
  },
  // 中标/成交数据分析--采购量统计分析--各页面标讯列表数据
  // "pageNum": 50, //页码
  // "pageSize": 10, //显示数
  // "listSortType": 1 //排序方式(1按照中标成交金额排序2按公告日期排序)
  getStatisticsArticleList(listSortType, pageNum, pageSize) {
    let d = JSON.parse(JSON.stringify(store.state.statisticsParams))
    delete d.chartsSort
    let mustNotIds = sessionStorage.mustNotIds || ''
    return post('/dataStatistics/getAmountPurchasedStatisticsArticleList', {
      ...d, mustNotIds, listSortType, pageNum, pageSize
    })
  },
  /**
   * 导出数据  参数与获取列表数据一致
   * @param listSortType
   * @param pageNum
   * @param pageSize
   * @returns {Promise}
   */
  getExportArticleList(listSortType, pageNum, pageSize) {
    let d = JSON.parse(JSON.stringify(store.state.statisticsParams))
    delete d.chartsSort
    let mustNotIds = sessionStorage.mustNotIds || ''
    return post('/dataStatistics/getExportArticleList', {
      ...d, mustNotIds, listSortType, pageNum, pageSize
    }, {responseType: 'blob', timeout: 60000 * 3})
  },
  // 趋势对比数据(详情页)--折线图数据
  // "comparisonType": 2, //折线图同比/环比开启方式(0不开启1开启同比2开启环比)
  getAmountLineData(comparisonType) {
    let d = store.state.statisticsParams
    let mustNotIds = sessionStorage.mustNotIds || ''
    return post('/dataStatistics/getPurchasedComparisonAmountLineData', {
      ...d, mustNotIds, comparisonType
    })
  },
  // 地区采购量及排名(详情页)--地图数据
  // "isCity": 2, //0大地图模式传递1单个省模式(大地图模式可以传省、市，不同省市可以混合，单省模式只能单省的省或市)
  getAreaPurchasedData(isCity) {
    let d = JSON.parse(JSON.stringify(store.state.statisticsParams))
    let mustNotIds = sessionStorage.mustNotIds || ''
    return post('/dataStatistics/getAreaPurchasedData', {
      ...d,
      mustNotIds, isCity
    })
  },
  // 地区采购量及排名(详情页)--排行数据
  // "isCity": 2, //0大地图模式传递1单个省模式(大地图模式可以传省、市，不同省市可以混合，单省模式只能单省的省或市)
  // "comparisonType": 1 //折线图同比/环比开启方式(0不开启1开启同比2开启环比)
  getAreaPurchasedRankingData(isCity, comparisonType) {
    let d = JSON.parse(JSON.stringify(store.state.statisticsParams))
    let mustNotIds = sessionStorage.mustNotIds || ''
    return post('/dataStatistics/getAreaPurchasedRankingData', {
      ...d,
      mustNotIds, isCity, comparisonType
    })
  },

  // 行业占比及供应商排名(详情页)--(全)行业饼图数据
  getIndustryPurchasingData() {
    let d = JSON.parse(JSON.stringify(store.state.statisticsParams))
    let mustNotIds = sessionStorage.mustNotIds || ''
    return post('/dataStatistics/getIndustryPurchasingData', {
      ...d,
      mustNotIds
    })
  },
  // 采购市场排名(详情页)--(全)行业饼图数据
  getMarketPurchasingData() {
    let d = JSON.parse(JSON.stringify(store.state.statisticsParams))
    d.market = ''
    let mustNotIds = sessionStorage.mustNotIds || ''
    return post('/dataStatistics/getMarketPurchasingData', {
      ...d,
      mustNotIds
    })
  },
  // 标的物及供应商排名(详情页)--(全)标的物统计数据
  getSuitableTargetPurchasingData(industryKeyword = '') {
    let d = JSON.parse(JSON.stringify(store.state.statisticsParams))
    let mustNotIds = sessionStorage.mustNotIds || ''
    return post('/dataStatistics/getSuitableTargetPurchasingData', {
      ...d,
      mustNotIds, industryKeyword
    })
  },
  // 趋势对比数据(详情页)--项目金额排行
  getAmountPurchasedStatisticsAmountRankingData() {
    let d = JSON.parse(JSON.stringify(store.state.statisticsParams))
    let mustNotIds = sessionStorage.mustNotIds || ''
    return post('/dataStatistics/getAmountPurchasedStatisticsAmountRankingData', {
      ...d,
      mustNotIds
    })
  },
  // 趋势对比数据(详情页)--供应商排行排行
  getAmountPurchasedStatisticsWinningBidderRankingData() {
    let d = JSON.parse(JSON.stringify(store.state.statisticsParams))
    let mustNotIds = sessionStorage.mustNotIds || ''
    return post('/dataStatistics/getAmountPurchasedStatisticsWinningBidderRankingData', {
      ...d,
      mustNotIds
    })
  },
  // 趋势对比数据(详情页)--采购人排名
  getAmountPurchasedStatisticsCompanyNameRankingData() {
    let d = JSON.parse(JSON.stringify(store.state.statisticsParams))
    let mustNotIds = sessionStorage.mustNotIds || ''
    return post('/dataStatistics/getAmountPurchasedStatisticsCompanyNameRankingData', {
      ...d,
      mustNotIds
    })
  },
  // 趋势对比数据(详情页)--代理机构排名
  getAmountPurchasedStatisticsAgencyNameRankingData() {
    let d = JSON.parse(JSON.stringify(store.state.statisticsParams))
    let mustNotIds = sessionStorage.mustNotIds || ''
    return post('/dataStatistics/getAmountPurchasedStatisticsAgencyNameRankingData', {
      ...d,
      mustNotIds
    })
  },
  // 趋势对比数据(详情页)--采购人、代理机构、供应商排名
  // "name": "上海飞龙国际工程技术有限公司；", //采购人、代理机构、供应商排行榜查询单个类型的金额数量统计
  // "nameType": 3, //(1采购人、2代理机构、3供应商)
  getAmountPurchasedStatisticsRankingInfoData(name, nameType) {
    let d = JSON.parse(JSON.stringify(store.state.statisticsParams))
    let mustNotIds = sessionStorage.mustNotIds || ''
    return post('/dataStatistics/getAmountPurchasedStatisticsRankingInfoData', {
      ...d,
      mustNotIds, name, nameType
    })
  },
  // 导出数据统计excel表格
  // exportType
  // 1 采购量趋势分析（中标成交金额）表头
  // 2 采购量趋势分析（中标成交数量）表头
  // 3 采购量趋势分析（大标排名）表头
  // 4 全销售行业占比表头
  // 5 XXX行业供应商排名
  // 6 采购市场占比
  // 7 XXX市场中标成交采购人排名
  // 8 XXX市场中标成交采购代理机构排名
  // 9 地区采销统计分析表头
  // 10 标的物中标成交供应商排名
  // 11 采购量统计分析
  getExportData(exportType, isCity, listSortType) {
    let d = JSON.parse(JSON.stringify(store.state.statisticsParams))
    let mustNotIds = sessionStorage.mustNotIds || ''
    return post('/dataStatistics/getExportData', {
      ...d,
      mustNotIds, exportType, isCity, listSortType, explain: `条件说明：${sessionStorage.HeaderTitle}`
    }, {responseType: 'blob', timeout: 60000 * 3})
  },
  // 标的物及供应商排名(详情页)--(单)标的物统计数据
  getSuitableTargetPurchasingSupplierData() {
    let d = JSON.parse(JSON.stringify(store.state.statisticsParams))
    let mustNotIds = sessionStorage.mustNotIds || ''
    return post('/dataStatistics/getSuitableTargetPurchasingSupplierData', {
      ...d,
      mustNotIds
    })
  },
  // 中标/成交数据分析--采购量统计分析--新增查询统计用例
  addDataStatisticsUserCase(caseName) {
    let userId = store.state.userid
    let d = JSON.parse(JSON.stringify(store.state.statisticsParams))
    let mustNotIds = sessionStorage.mustNotIds || ''
    let caseParameter = JSON.stringify({
      ...d,
      mustNotIds,
    })
    return post('/dataStatistics/addDataStatisticsUserCase', {
      userId,
      caseName,
      caseParameter
    })
  },
  // 中标/成交数据分析--采购量统计分析--获取查询统计用例
  getDataStatisticsUserCase() {
    let userId = store.state.userid
    return post('/dataStatistics/getDataStatisticsUserCase', {userId})
  },
  // 删除用例
  deleteDataStatisticsUserCase() {
    let userId = store.state.userid
    return post('/dataStatistics/deleteDataStatisticsUserCase', {userId})
  },
  // 移除标讯
  updateDataStatisticsUserCase(caseId, mustNotIds) {
    let d = JSON.parse(JSON.stringify(store.state.statisticsParams))
    let caseParameter = JSON.stringify({
      ...d,
      mustNotIds,
    })
    return post('/dataStatistics/updateDataStatisticsUserCase', {
      caseId, caseParameter
    })
  },
  // caoyong
  //--品目管理
  /**
   *拉取完善品目分组
   * @param paramObj{"completeId": "aaa" }
   * @returns {Promise}
   */
  labelPullGroup(paramObj = {}) {
    return post('/label/pullGroup', paramObj)
  },
  /**
   *获取完善品目分组列表
   * @param paramObj{"completeId": "aaa" }
   * @returns {Promise}
   */
  labelGetGroupList(paramObj = {}) {
    return post('/label/getGroupList', paramObj)
  },
  /**
   *获取完善品目标讯列表
   * @param paramObj  : {
   groupId: this.$route.query.dataId,
   dataMarkStatus: [],//0未完善，1已完善 ,[]转成null==全部
   keyWord: '',
   page: 1,
   size: 10,
   total: 0
   }
   * @returns {Promise}
   */
  labelGetDataList(paramObj = {}) {
    return post('/label/getDataList', paramObj)
  },

  /**
   * 完善品目编辑后保存并跳转
   * @param paramObj {"dictionaryPurchaserId": 20,

   "dataId": 1187,

   "itemCodeList": [
   "A01",
   "A10"
   ],

   "groupId": 20,

   "dataSortNum": 2,

   * "pageDirection": 2 }
   * @returns {Promise}
   */
  labelSaveDataResult(paramObj = {}) {
    return post('/label/saveDataResult', paramObj)
  },
  /**
   * 完善品目获取跳转页码
   * @param paramObj {
   "dataId": 1187,
   "groupId": 20,
   "dataSortNum": 2,
   * "pageDirection": 2 }
   * @returns {Promise}
   */
  labelGetDataId(paramObj = {}) {
    return post('/label/getDataId', paramObj)
  },
  /**
   *
   * @param paramObj{"groupId": 20 }
   * @returns {Promise}
   */
  labelSubmit(paramObj = {}) {
    return post('/label/submit', paramObj)
  },


  /**
   * 永久删除标讯与标讯相关操作
   * @param paramObj{"groupId": 20 }
   * @returns {Promise}
   */
  labelDeleteData(paramObj = {}) {
    return post('/label/deleteData', paramObj)
  },

  /**
   *获取公告原文
   * @param paramObj {id:xxx}
   * @returns {Promise}
   */
  labelGetDataInfo(paramObj = {}) {
    return post('/label/getDataInfo', paramObj)
  },
  /**
   *获取品目多选
   * @param paramObj {keyword：嘻嘻嘻}
   * @returns {Promise}
   */
  labelSelectItem(paramObj = {}) {
    return post('/label/selectItem', paramObj)
  },

  //标准库
  /* 查询采购人列表
  * "standardName": "天津", //采购人名称
 "page": 1, //页码
 "size": 10 //每页条数
 * */
  standardCompanyList(paramObj = {}) {
    return post('/standard/company/list', paramObj)
  },
  /* 新增采购人*/
  standardCompanyAdd(paramObj = {}) {
    return post('/standard/company/add', paramObj)
  },
  /* 编辑采购人*/
  standardCompanyEdit(paramObj = {}) {
    return post('/standard/company/edit', paramObj)
  },
  /*查询代理机构列表*/

  standardAgencyList(paramObj = {}) {
    return post('/standard/agency/list', paramObj)
  },
  /* 新增代理机构*/
  standardAgencyAdd(paramObj = {}) {
    return post('/standard/agency/add', paramObj)
  },
  /* 编辑理机构*/
  standardAgencyEdit(paramObj = {}) {
    return post('/standard/agency/edit', paramObj)
  },

  /*查询供应商列表*/

  standardWinningBidderList(paramObj = {}) {
    return post('/standard/winningBidder/list', paramObj)
  },
  /* 新增供应商*/
  standardWinningBidderAdd(paramObj = {}) {
    return post('/standard/winningBidder/add', paramObj)
  },
  /* 编辑供应商*/
  standardWinningBidderEdit(paramObj = {}) {
    return post('/standard/winningBidder/edit', paramObj)
  },

  // caoyong-end
  // 从es恢复标讯数据到mysql
  restoreToDB(id) {
    return post('/bid/restoreToDB', {id})
  },
}
